module.exports = __webpack_public_path__ + "static/gallery-img-16-3f2ff0079950ccd17140c987f5ccf789.jpg";